/**
 * Vuely Global Components
 */
// section tooltip
import UploadFile from './components/UploadFile.vue'
import DisplayImage from './components/DisplayImage.vue'
import VueQRCodeComponent from 'vue-qrcode-component'

const GlobalComponents = {
   install(Vue) {
      Vue.component('UploadFile', UploadFile);
      Vue.component('DisplayImage', DisplayImage);
      Vue.component('QRCode', VueQRCodeComponent);
   }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js